export class UpdateTagEditorValidation {
  static readonly type = '[TagEditorValidation] Update Tag Editor Validation'

  constructor(
    public readonly clientId: number,
    public readonly hasTags: boolean,
    public readonly isValid: boolean,
  ) {}
}

export class ClearTagEditorValidation {
  static readonly type = '[TagEditorValidation] Clear Tag Editor Validation'

  constructor(public readonly clientId: number) {}
}
